<template>
    <div class="col-md-12">
        <button class="btn btn-success" style="border-radius: 2px !important;" @click="openModal()">
            <i class="fas fa-bell"></i> Adicionar nova prioridade
        </button>

        <b-row>
            <b-col md="12">
                <b-table striped hover bordered sort-icon-left show-empty :items="tbData" :fields="fields"
                    :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered"
                    :current-page="currentPage" :per-page="perPage" thead-class="font-weight-bold">

                    <template v-if="loading" #empty>
                        <div class="text-center">
                            <b-spinner variant="dark" small></b-spinner> Processando, por favor, aguarde...
                        </div>
                    </template>

                    <template v-else #empty>
                        <h6 style="text-align: center">Nenhum resultado encontrado.</h6>
                    </template>

                    <template #cell(name)="data">
                        <span class="highlight-badge" :style="dinamicStyle(data.item.color)">{{ data.item.name }}</span>
                    </template>

                    <template #cell(created_at)="data">
                        {{ handleCreatedAt(data.item.created_at, data.item.immutable) }}
                    </template>

                    <template #cell(time)="data">
                        {{ convertSecondsToTime(data.item.time) }}
                    </template>

                    <template #cell(percent_alert)="data">
                        {{ data.item.percent_alert ? `${data.item.percent_alert}%` : '' }}
                    </template>

                    <template v-slot:cell(view-button)="{ item }">
                        <span>
                            <b-btn id="view-button" @click.prevent="openModal(item)" style="border-radius: 3px !important;">
                                <i class="far fa-eye" aria-hidden="true"></i>
                            </b-btn>
                        </span>
                    </template>
                </b-table>
            </b-col>
        </b-row>

        <b-row class="justify-content-between">
            <b-col md="4">
                <b-form-group label="Registros por página" label-for="per-page-select" label-cols-md="6" label-align-sm="right"
                label-size="sm" class="mb-0 align-self-center">
                <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right" size="md"
                class="my-0"></b-pagination>
            </b-col>
        </b-row>
        
        <PriorityTicketModal ref="addPriority" @updatePriorityTable="updateTable"></PriorityTicketModal>
    </div>
</template>

<script>
import axios from 'axios';
import PriorityTicketModal from './PriorityTicketModal.vue';
import { dinamicStyle, formatDate, convertSecondsToTime, handleCreatedAt } from '../../../helpers/utils'

export default {
    name: "ManagePriorities",
    components: { PriorityTicketModal },
    data() {
        return {
            tbData: [],
            loading: false,
            fields: [
                {
                    key: 'created_at',
                    label: 'Data',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'name',
                    label: 'Nome',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'time',
                    label: 'Tempo (SLA)',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'level',
                    label: 'Nível',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'percent_alert',
                    label: 'Alerta de SLA',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'view-button',
                    label: 'Visualizar',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff', width: '100px' }
                },
            ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Ver mais" }],
            sortBy: '',
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
        }
    },
    created() {
        this.getDataTable();
    },
    methods: {
        dinamicStyle,
        formatDate,
        convertSecondsToTime,
        handleCreatedAt,
        openModal(value = null) {
            this.$refs.addPriority.openModal(value);
        },
        getDataTable() {
            axios.get("/ticket/priority")
                .then(({ data }) => {
                    this.tbData = data;
                    this.totalRows = data.length;
                })
                .catch((error) => console.error(error))
        },
        updateTable(data) {
            if (!data.id) return;
            const found = this.tbData.find(el => el.id === data.id);
            if (found) {
                Object.assign(found, data);
            } else {
                this.tbData.push(data);
            }
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
    }
}
</script>

<style scoped>
.highlight-badge  {
    padding: 5px 10px;
    border-radius: 5px !important;
    font-weight: bold;
}
</style>